import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class UserApi extends CollectionApi {
  /**
   * @description Set up the api for getting admin user information.
   */
  constructor() {
    super('/api/users', {
      skip: 0,
      limit: 50,
      sort: 'email', // Prepend with a '-' to reverse default sort direction
      search: {
        fields: [
          'email',
        ],
        searchTerm: '',
      },
    });
    this.baseUrl = '/api/users';
  }

  /**
   * @description Gets the status of the current admin user session.
   */
  // eslint-disable-next-line class-methods-use-this
  getSession() {
    // not using `this` in this function because the url is off of the root,
    // and the interface that results when this is made static is ugly.
    return axios.get('/session')
      .then(resp => Promise.resolve((resp && resp.data) || ''));
  }

  /**
   * @description Resets an admin user's password
   * @param {String} payload.currentPassword - The admin user's current password
   * @param {String} payload.newPassword - The admin user's new password
   * @param {String} payload.newPassword2 - The admin user's new password
   */
  resetPassword(payload) {
    return axios.put(`${this.baseUrl}/resetPassword`, payload);
  }
}

export default new UserApi();
